import { createEntityQuery } from '../../createEntityQuery';
import {
  UserDefinedFieldValuesService,
  type Wealthlane_CustomerService_Dtos_UserDefinedFieldValues_UserDefinedFieldValuesDto,
} from '@wealthlane/api-services/wealthlane-customer-service';

export type UserDefinedFieldValuesParams = {
  moduleId: number;
  moduleFormId: string;
};

export const useGetUserDefinedFieldValues = createEntityQuery<
  Wealthlane_CustomerService_Dtos_UserDefinedFieldValues_UserDefinedFieldValuesDto[],
  UserDefinedFieldValuesParams
>({
  queryKey: ['userDefinedFieldValues'],
  queryFn: ({ moduleId, moduleFormId }) =>
    UserDefinedFieldValuesService.getApiCustomerApiAppUserDefinedFieldValuesUserDefinedFieldValues(
      moduleId,
      moduleFormId,
    ),
});
